import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
var SvgImprovedDesk32 = props => _jsx("svg", _objectSpread(_objectSpread({
  width: 27,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: _jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5 12a.5.5 0 0 1 0 1H25l1 11h-1l-1-11H14l-1 11h-1l1-11h-1.5a.5.5 0 0 1 0-1h15ZM8 4a1 1 0 0 1 1 1v9a1 1 0 0 1 1 1v3H9v6H8v-6H2v6H1v-6H0v-3a1 1 0 0 1 1-1V5a1 1 0 0 1 1-1h6Zm1 11H1v2h8v-2ZM8 5H2v9h6V5Zm16-5v3h3v1h-3v3h-1V3.999L20 4V3l3-.001V0h1Z",
    fill: props.color || "#58595B"
  })
}));
export default SvgImprovedDesk32;